import { render, staticRenderFns } from "./IndexProducts.vue?vue&type=template&id=7e2b8144&"
import script from "./IndexProducts.vue?vue&type=script&lang=js&"
export * from "./IndexProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports